import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const contactsFirstNameViewer = {
    autoComplete: 'given-name',
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map